import { useAuth } from "@/lib/auth";

// Team assistants work inside the owner's account; owners (and solo users) have no team_role.
export function useTeam() {
  const { user } = useAuth();
  const role = user?.team_role || null;
  return {
    role,
    isAssistant: !!role,
    canPhotos: role !== "lister",
    canList: role !== "photos",
    ownerName: user?.team_owner_name || "",
    hideQueue: !!role && !!user?.team_hide_queue,
    researchOnly: !role && !!user?.research_only,
    researchPlan: !role && !!user?.research_plan,
  };
}

export const ROLE_LABELS = { photos: "Photos", lister: "Lister", both: "Photos + Lister" };
export const ROLE_HINTS = {
  photos: "Snaps photos and makes drafts. Can't publish or list.",
  lister: "Lists drafts to eBay and other sites. Can't upload photos.",
  both: "Snaps photos, drafts and lists.",
};
